<template>
  <div class="layout-main">
    <div class="layout-table-basic">
      <div class="toolbar">
        <div class="search">
          <el-form :inline="true">
            <el-form-item label="姓名/手机号 ：">
              <el-input size="small" placeholder="请输入" v-model="filterData.keyword" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="small" @click="handleSearchReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="handle">
          <el-button size="small" type="primary" @click="handleCreate('form')">添加</el-button>
        </div>
      </div>

      <div class="table">
        <el-table v-loading="isTableloading" :data="tableData" stripe highlight-current-row style="width: 100%" height="100%">
          <el-table-column prop="" label="" width="10"> </el-table-column>
          <el-table-column prop="id" label="管理员ID" width="80"> </el-table-column>
          <el-table-column prop="realname" label="姓名" min-width="100"> </el-table-column>
          <el-table-column prop="username" label="手机号" min-width="100"></el-table-column>
          <el-table-column prop="createtime" label="创建时间" min-width="100"></el-table-column>
          <el-table-column label="操作" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button @click.native.stop="handleEdit(scope.row, 'form')" type="text">编辑</el-button>
              |
              <el-button @click.native.stop="handlePassword(scope.row, 'formPassword')" type="text">修改密码</el-button>
              |
              <el-popconfirm cancel-button-type="Primary" icon="el-icon-info" icon-color="red" :title="'您确定要删除【' + scope.row.username + '】管理管账户吗？'" @confirm="handleDeleteConfirm(scope.row)" placement="bottom-end">
                <el-button type="text" slot="reference" @click.native.stop="" style="color:red">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination">
        <el-pagination :page="searchParams.page" :page-size="searchParams.limit" :total="total" background layout="total, sizes, prev, pager, next" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>

      <!-- 添加、编辑，模态框组件 -->
      <el-dialog :title="dialogTitle" :visible="dialogVisible" @close="dialogVisible = false" width="600px">
        <el-form :model="form" ref="form" label-width="120px">
          <el-form-item label="姓名" prop="realname">
            <el-input v-model="form.realname" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="username">
            <el-input v-model="form.username" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="handleSubmit()">保存</el-button>
        </div>
      </el-dialog>

      <!-- 修改密码模态框组件 -->
      <el-dialog title="修改密码" :visible="dialogPasswordVisible" @close="dialogPasswordVisible = false" width="600px">
        <el-form :model="formPassword" ref="formPassword" label-width="120px">
          <el-form-item label="新密码" prop="password">
            <el-input v-model="formPassword.password" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogPasswordVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click="handlePasswordSubmit()">保存</el-button>
        </div>
      </el-dialog>

      <!-- 列表详情，抽屉组件 -->
      <el-drawer title="详情" :visible.sync="drawerDetailVisible">
        <div class="layout-drawer-handle">
          <el-button type="primary" size="small" @click="handleEdit(drawerDetailObj, 'form')">编辑</el-button>
          <el-popconfirm cancel-button-type="Primary" icon="el-icon-info" icon-color="red" :title="'您确定要删除【' + drawerDetailObj.salesTitle + '】记录吗？'" @confirm="handleDeleteConfirm(drawerDetailObj)" placement="bottom-end">
            <el-button type="danger" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </div>
        <div class="layout-drawer-detail">
          <div class="layout-drawer-detail-top">
            <div class="layout-drawer-detail-top-title">
              基础信息
            </div>
          </div>
          <div class="layout-drawer-detail-main">
            <div class="layout-drawer-detail-list">
              <DrawerDetail liLabel="登录账号" :liValue="drawerDetailObj.username"></DrawerDetail>
              <DrawerDetail liLabel="姓名" :liValue="drawerDetailObj.realname"></DrawerDetail>
              <DrawerDetail liLabel="手机号" :liValue="drawerDetailObj.tel"></DrawerDetail>
              <DrawerDetail liLabel="创建时间" :liValue="drawerDetailObj.createtime"></DrawerDetail>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import Request from '@/api/admin';

import DrawerDetail from '../../../layout/console/components/DrawerDetail.vue';
export default {
  components: {
    DrawerDetail,
  },

  data() {
    return {
      //列表相关
      tableData: null,
      isTableloading: false,
      total: 0,

      //查询区域字段
      filterData: {
        keyword: '',
      },

      //发送查询请求字段
      searchParams: {
        limit: 10,
        page: 1,
      },

      //模态框
      isEdit: false,
      idEdit: '',
      dialogVisible: false,
      dialogTitle: '添加',

      drawerDetailVisible: false,
      drawerDetailObj: {},

      form: {
        username: '',
        realname: '',
      },

      //
      dialogPasswordVisible: false,
      idEditPassword: '',
      formPassword: {
        password: '',
      },
    };
  },

  mounted() {
    this.getTableList();
  },

  methods: {
    getTableList() {
      this.isTableloading = true;
      Request.page(this.searchParams).then((res) => {
        console.log(res);
        this.isTableloading = false;
        if (res && res.code === 200) {
          if (res.data.list.length > 0) {
            this.renderTable(res.data.list);
          } else {
            if (this.searchParams.page > 1) {
              this.searchParams.page--;
              this.getTableList();
            } else {
              this.renderTable(res.data.list);
            }
          }
          this.total = res.data.total;
        }
      });
    },

    // 渲染表格
    renderTable(data) {
      this.tableData = [];
      data.forEach((e) => {
        this.tableData.push(e);
      });
    },

    //查询搜索按钮
    handleSearch() {
      for (let key in this.filterData) {
        this.searchParams[key] = this.filterData[key];
      }

      for (let key in this.searchParams) {
        if (!this.searchParams[key]) {
          delete this.searchParams[key];
        }
      }

      this.searchParams.page = 1;
      this.getTableList();
    },

    //查询重置按钮
    handleSearchReset() {
      for (let key in this.filterData) {
        this.filterData[key] = '';
      }

      this.handleSearch();
    },

    //分页改变每页显示数量
    handleSizeChange(val) {
      this.searchParams.page = 1;
      this.searchParams.limit = val;
      this.getTableList();
    },

    //分页跳转至当前页
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getTableList();
    },

    //添加按钮
    handleCreate(formName) {
      this.isEdit = false;
      this.dialogTitle = '添加';
      this.dialogVisible = true;

      this.$nextTick(() => {
        this.$refs[formName].resetFields();

        for (let key in this.form) {
          this.form[key] = '';
        }
      });
    },

    //列表里操作列编辑按钮
    handleEdit(row, formName) {
      this.isEdit = true;
      this.idEdit = row.id;
      this.dialogTitle = '编辑';
      this.dialogVisible = true;

      this.$nextTick(() => {
        this.$refs[formName].resetFields();

        for (let key in this.form) {
          this.form[key] = row[key];
        }
      });
    },

    //添加、编辑模态框的保存提交按钮
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = Object.assign({}, this.form);
          data.tel = this.form.username;

          if (!this.isEdit) {
            Request.create(data).then((res) => {
              if (res && res.code === 200) {
                this.msgSuccess('添加成功');
                this.searchParams.page = 1;
                this.getTableList();
              } else {
                this.msgError('添加失败：' + res.msg);
              }
              this.dialogVisible = false;
            });
          } else {
            data.id = this.idEdit;
            data.tel = this.form.username;
            Request.update(data).then((res) => {
              if (res && res.code === 200) {
                this.msgSuccess('编辑成功');
                this.getTableList();

                if (this.drawerDetailVisible) this.drawerDetailObj = Object.assign(this.drawerDetailObj, data);
              } else {
                this.msgError('编辑失败：' + res.msg);
              }
              this.dialogVisible = false;
            });
          }
        } else {
          return false;
        }
      });
    },

    //列表里操作列删除按钮弹出提示框的 确定 按钮
    handleDeleteConfirm(row) {
      let loading = this.$loading({ background: 'rgba(0, 0, 0, 0.6)' });

      Request.remove(row.id).then((res) => {
        if (res && res.code == 200) {
          this.msgSuccess('删除成功');
          loading.close();
          this.getTableList();

          if (this.drawerDetailVisible) this.drawerDetailVisible = false;
        }
      });
    },

    //点击列表row右侧弹出详情框
    handleDrawerDetailVisible(row) {
      this.drawerDetailObj = row;
      this.drawerDetailVisible = true;
    },

    //
    //列表里操作列编辑按钮
    handlePassword(row, formName) {
      this.idEditPassword = row.id;
      this.dialogPasswordVisible = true;

      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },

    //
    handlePasswordSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = {
            id: this.idEditPassword,
            password: this.formPassword.password,
          };
          Request.update(data).then((res) => {
            if (res && res.code === 200) {
              this.msgSuccess('修改密码成功');
              this.getTableList();
            } else {
              this.msgError('修改失败：' + res.msg);
            }
            this.dialogPasswordVisible = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scope></style>
